export default "__VITE_PUBLIC_ASSET__82fe3362__"